import { axiosRequest } from 'src/utils/api/axiosRequest';
import { CURRENT_USER_PERMISSIONS_QUERY_BASE } from 'src/graphql/currentUserPermissions/query';
import { FETCH_CURRENT_USER, FETCH_CURRENT_USER_PERMISSIONS } from 'src/redux/actionTypes';
import { USER_QUERY_BASE } from 'src/graphql/user/query';

export const fetchCurrentUserAction = id => (dispatch) => {
  dispatch({ type: FETCH_CURRENT_USER.INVOKE });

  return axiosRequest(USER_QUERY_BASE, { id })
    .then(response => dispatch({
      type: FETCH_CURRENT_USER.SUCCESS,
      payload: response.data
    }))
    .catch(error => dispatch({
      type: FETCH_CURRENT_USER.ERROR,
      error: error.response || 'error'
    }));
};

export const fetchCurrentUserPermissionsAction = () => (dispatch) => {
  dispatch({ type: FETCH_CURRENT_USER_PERMISSIONS.INVOKE });

  return axiosRequest(CURRENT_USER_PERMISSIONS_QUERY_BASE)
    .then(response => dispatch({
      type: FETCH_CURRENT_USER_PERMISSIONS.SUCCESS,
      payload: response.data
    }))
    .catch(error => dispatch({
      type: FETCH_CURRENT_USER_PERMISSIONS.ERROR,
      error: error.response || 'error'
    }));
};
